import { z } from 'zod';
import { baseLastBowelMovement, baseLastBowelMovementRefined } from './last-bowel-movement';
const baseGISymptoms = z.object({
    wnl: z.boolean().optional(),
    nauseaVomiting: z.string().optional(),
    vomitingTimesPerDay: z.string().optional(),
    vomitingDaysDuration: z.string().optional(),
    vomitingCharacteristics: z.array(z.string()).optional(),
    bowelHabits: z.array(z.string()).optional(),
    giBleedingType: z.string().optional(),
    giBleedingMdNotification: z.string().optional(),
    otherGiFindings: z.string().optional(),
});
const baseGISymptomsRefined = baseGISymptoms.refine((data) => data.wnl ||
    data.nauseaVomiting?.trim() ||
    data.vomitingTimesPerDay?.trim() ||
    data.vomitingDaysDuration?.trim() ||
    data.vomitingCharacteristics?.length ||
    data.bowelHabits?.length ||
    data.giBleedingType?.trim() ||
    data.giBleedingMdNotification?.trim() ||
    data.otherGiFindings?.trim(), { message: 'At least one answer is required', path: [] });
const baseAbdomenSchema = z.object({
    wnl: z.boolean().optional(),
    contour: z.string().optional(),
    girth: z.string().optional(),
    ascitesPresent: z.boolean().optional(),
    tenderness: z.string().optional(),
    tendernessMdNotification: z.string().optional(),
    additionalFindings: z.string().optional(),
    rigidityMdNotification: z.string().optional(),
});
const baseAbdomenSchemaRefined = baseAbdomenSchema.refine((data) => data.wnl ||
    data.contour?.trim() ||
    data.girth?.trim() ||
    data.ascitesPresent ||
    data.tenderness?.trim() ||
    data.tendernessMdNotification?.trim() ||
    data.additionalFindings?.trim() ||
    data.rigidityMdNotification?.trim(), { message: 'At least one answer is required', path: [] });
const baseBowelSoundsSchema = z.object({
    wnl: z.boolean().optional(),
    ruq: z.string().optional(),
    luq: z.string().optional(),
    rlq: z.string().optional(),
    llq: z.string().optional(),
});
const baseBowelSoundsSchemaRefined = baseBowelSoundsSchema.refine((data) => data.wnl || data.ruq?.trim() || data.luq?.trim() || data.rlq?.trim() || data.llq?.trim(), { message: 'At least one answer is required', path: [] });
const baseGiPainSchema = z.object({
    wnl: z.boolean().optional(),
    ruq: z.string().optional(),
    luq: z.string().optional(),
    rlq: z.string().optional(),
    llq: z.string().optional(),
});
const baseGiPainSchemaRefined = baseGiPainSchema.refine((data) => data.wnl || data.ruq?.trim() || data.luq?.trim() || data.rlq?.trim() || data.llq?.trim(), { message: 'At least one answer is required', path: [] });
const baseWeightChangeSchema = z.object({
    wnl: z.boolean().optional(),
    change: z.string().optional(),
});
const baseWeightChangeSchemaRefined = baseWeightChangeSchema.refine((data) => data.wnl || data.change?.trim(), {
    message: 'At least one answer is required',
    path: [],
});
const baseClinicalNarrativeSection = z.object({
    wnl: z.boolean().optional(),
    narrative: z.string().optional(),
});
const baseClinicalNarrativeSectionRefined = baseClinicalNarrativeSection.refine((data) => data.wnl || data.narrative?.trim(), {
    message: 'At least one answer is required',
    path: [],
});
export const baseGastrointestinalSchema = z.object({
    lastBowelMovement: baseLastBowelMovement,
    giSymptoms: baseGISymptoms.optional(),
    abdomen: baseAbdomenSchema.optional(),
    bowelSounds: baseBowelSoundsSchema.optional(),
    pain: baseGiPainSchema.optional(),
    weightChange: baseWeightChangeSchema.optional(),
    clinicalNarrative: baseClinicalNarrativeSection.optional(),
});
export const baseGastrointestinalSchemaRefined = z.object({
    lastBowelMovement: baseLastBowelMovementRefined,
    giSymptoms: baseGISymptomsRefined,
    abdomen: baseAbdomenSchemaRefined,
    bowelSounds: baseBowelSoundsSchemaRefined,
    pain: baseGiPainSchemaRefined,
    weightChange: baseWeightChangeSchemaRefined,
    clinicalNarrative: baseClinicalNarrativeSectionRefined,
});
